<h1 class="border-gray border-bottom text-center pb-4 mb-5">User Photo Submissions</h1>
<div class="text-end mb-4"></div>

<div class="card border-0 bg-white shadow-sm main-container">
    <div class="batches-selector-container">
        <ng-select
            [(ngModel)]="selectedBatch"
            [clearable]="false"
            [searchable]="false"
            (ngModelChange)="getPhotos($event.id)"
            placeholder="Select Batch">
            <ng-option
                *ngFor="let batch of batches"
                [value]="batch">
                {{ batch.id }}
            </ng-option>
        </ng-select>
    </div>
    <div
        class="photos-container"
        *yssIsLoading="isLoading">
        <div
            *ngFor="let photo of photos; let i = index"
            class="photo-holder"
            [ngClass]="{ isWinner: photo.isWinner === '1' }"
            (click)="viewPhoto(i)">
            <div
                *ngIf="!selectedBatch.winnerId || photo.isWinner === '1'"
                class="winner-cup-icon"
                (click)="winnerSelected(photo)">
                <img src="/assets/images/winner-cup.png" />
            </div>
            <img src="{{ photo.url }}" />
            <div class="photo-creator">
                <div class="photo-creator-name">{{ photo.firstname }} {{ photo.surname }}</div>
                <div class="photo-creator-email">{{ photo.email }}</div>
            </div>
        </div>
    </div>
    <div
        class="no-photos-yet-msg"
        *ngIf="!photos.length && !isLoading && selectedBatch">
        No photos in this batch yet
    </div>
</div>

<app-photo-viewer
    [photos]="photos"
    [veiwingPhotoIndex]="veiwingPhotoIndex"
    (closed)="veiwerClosed()"
    (flipped)="photosFlipped($event)"
    (winnerSelected)="winnerSelected($event)"></app-photo-viewer>
